import truck from "../../images/ImprovedFundraiserPage/truck.svg";
import lock from "../../images/ImprovedFundraiserPage/lock.svg";
import heart from "../../images/ImprovedFundraiserPage/heart.svg";
import logo from "../../images/ImprovedFundraiserPage/MaMF.svg";
import { Typography, useTheme } from "@mui/material";
import packageJson from "../../../package.json";
const FundraiserFooter = () => {
  const theme = useTheme();
  const appVersion = packageJson.version;

  return (
    <section className="footer-bg">
      <div className="mx-auto px-3 py-5 py-lg-5 sec-wrapper">
        <div className="row g-4 pb-5">
          <div className="col-12 col-md-6 col-lg-4 d-flex flex-column justify-content-center align-items-center gap-4">
            <img src={truck} alt="truck" />
            <h1 className="h2 h1-md fw-bold text-white text-center font-fraunces">
              <span className="text-secondary-custom">Free Shipping </span>{" "}
              <br />
              on Orders of $120 or more
            </h1>
            <p className="fs-6 text-center text-white px-4">
              Excluding donations. Enjoy fast, free delivery when your cart hits
              $120 or more (within the continental US) — no surprise fees at
              checkout.
            </p>
          </div>
          <div className="col-12 col-md-6 col-lg-4 d-flex flex-column justify-content-center align-items-center gap-4">
            <img src={lock} alt="lock" />
            <h1 className="h2 h1-md fw-bold text-white text-center font-fraunces">
              <span className="text-secondary-custom">Safe and Secure</span>{" "}
              <br />
              Payments{" "}
            </h1>
            <p className="fs-6 text-center text-white px-4">
              All payments are protected and encrypted, so you can give and shop
              with total confidence.
            </p>
          </div>
          <div className="col-12 col-md-6 col-lg-4 d-flex flex-column justify-content-center align-items-center gap-4">
            <img src={heart} alt="heart" />
            <h1 className="h2 h1-md fw-bold text-white text-center font-fraunces">
              Making
              <br />a{" "}
              <span className="text-secondary-custom">Real Impact</span>{" "}
            </h1>
            <p className="fs-6 text-center text-white px-4">
              A percentage of every dollar you spend supports the fundraiser
            </p>
          </div>
        </div>
        <div className="py-5 border-bottom border-top footer-border">
          <h1 className="footer-heading fw-bold text-white text-center font-fraunces">
            Every contribution counts —{" "}
            <span className="text-secondary-custom">thank you!</span>
          </h1>
        </div>

        <div className="pt-5 row g-4 align-items-end justify-content-between">
          <div className="col-12 col-md-4">
            <div className="d-flex flex-column gap-4">
              <img src={logo} alt="Logo" className="logo-img mx-auto mx-md-0" />
              <p className="fs-5 fs-md-4 text-white text-center text-md-start">
                Custom fundraising made simple <br /> for youth teams, schools,
                and organizations.
              </p>
            </div>
          </div>
          <div className="col-12 col-md-8">
            <div className="d-flex flex-column flex-lg-row gap-4 justify-content-end align-items-md-end">
              <a
                href="/"
                className="fs-6 fw-semibold text-white text-center text-md-start text-decoration-none"
              >
                Home
              </a>

              <a
                href="/about-us"
                className="fs-6 fw-semibold text-white text-center text-md-start text-decoration-none"
              >
                About us
              </a>
              <a
                href="/contact-us"
                className="fs-6 fw-semibold text-white text-center text-md-start text-decoration-none"
              >
                Contact us
              </a>
              <a
                href="/faq"
                className="fs-6 fw-semibold text-white text-center text-md-start text-decoration-none"
              >
                FAQ
              </a>
              <a
                href="/privacy-policy"
                className="fs-6 fw-semibold text-white text-center text-md-start text-decoration-none"
              >
                Privacy Policy
              </a>
              <p className="small text-white text-center text-md-start mb-0">
                © 2025 Make a Memory Family.{" "}
                <br className="d-md-none d-block" /> All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Version Info */}
      <div className="text-center mt-2">
        <Typography
          variant="caption"
          className="text-white text-md text-decoration-none"
          sx={{ fontSize: "0.7rem" }}
        >
          v{appVersion}
        </Typography>
      </div>
    </section>
  );
};

export default FundraiserFooter;
